import * as types from '@store/types'
import FavoriteQuery from '@queries/Favorite'
import FavoritesQuery from '@queries/Favorites'
import FavoriteCampaignsQuery from '@queries/FavoriteCampaigns'
import request from '@queries'

const getFavoriteSearchFilters = (options) => ({
  exclusive: options.exclusive ? options.company : null,
  cashback: options.cashback ? 'cashback' : null
})

const getFavoriteSearchOrdinators = (options) => ({
  desc: options.discount ? 'value'
    : options.likes ? 'liked_count'
      : undefined,

  asc: options.nearby ? '?'
    : options.alphabetical ? 'partner.name'
      : undefined
})

const state = {
  favorites: []
}

const getters = {
  [types.FAVORITES]: ({ favorites }) => favorites
}

const mutations = {
  [types.FAVORITES]: (state, payload) => {
    state.favorites = [...(payload || [])]
  },
  [types.FAVORITE_ADD]: (state, slug) => {
    state.favorites = [...state.favorites, slug]
  },
  [types.FAVORITE_REMOVE]: (state, slug) => {
    state.favorites = state.favorites.filter(_ => _ !== slug)
  }
}

const actions = {
  [types.FAVORITES_SEARCH]: async (_, options) => {
    const filters = getFavoriteSearchFilters(options)
    const ordinators = getFavoriteSearchOrdinators(options)
    const response = await request(FavoriteCampaignsQuery, {
      ...options,
      ...filters,
      ...ordinators
    })

    const { data: campaigns = [], page, quantity } = response.data.data.favoritedCampaigns || {}

    return {
      page,
      quantity,
      campaigns
    }
  },
  [types.FAVORITES]: async ({ commit }) => {
    const response = await request(FavoritesQuery, {})
    const favorites = response.data.data.favorites
    commit(types.FAVORITES, favorites)
    return favorites
  },
  [types.FAVORITE_CAMPAIGN]: async ({ dispatch, commit, getters }, { slug, partner: { name: title } }) => {
    const response = await request(FavoriteQuery, {
      slug
    })
    const isFavorited = response.data.data.favorite
    const options = getters[types.SEARCH_OPTIONS]

    if (!isFavorited && options.favorites) {
      const info = getters[types.SEARCH_INFO]
      commit(types.SEARCH_INFO, { ...info, quantity: info.quantity - 1 })
    }

    const addOrRemove = (isFavorited ? 'ADD' : 'REMOVE')
    const type = 'SEARCH_FAVORITE_' + addOrRemove

    const text = (isFavorited ? ' adicionada a' : ' removida d') + 'os favoritos'

    const feedback = {
      text,
      type: 'favorite',
      title
    }

    if (('query' in options) && !('favorites' in options)) {
      const searchFavoriteType = 'FAVORITE_' + addOrRemove
      commit(types[searchFavoriteType], slug)
    }

    commit(types[type], slug)

    dispatch(types.FEEDBACK, feedback)
    return isFavorited
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/favorite.js